import api from "../../api";

export const getAllSpecializationsFromEleks = () => (dispatch) =>
  api.specializationMapping.getAllSpecializationsMappingItems().then((res) =>
    dispatch({
      type: "GET_ALL_SPECIALIZATIONS_FROM_ELEKS",
      ...(res && res.data),
    })
  );
